<div class="options-display">
  <div class="warp" *ngFor="let op of optionsListDetails?.answerOptionItem">
    <div class="option" [ngClass]="{'pointer':!isDisableSignal$()}" (click)="isDisableSignal$()?null:chooseOption(op.guid,op.name)">
      <div class="img" 
        [ngClass]="{'selected':answer.value==op.guid}">
        <div class="inner-selected"></div>
      </div>
      <div>
        <p *ngIf="op.name!=''" class="text">{{op.name}}</p>
        <p *ngIf="op.name==''" translate class="text">questionBoard.edit.noValue</p>
      </div>
    </div>
  </div>
</div>
<!-- <p class="error" *ngIf="answer.invalid">{{answer.errors|json}}</p> -->